import Api from "../Api/Api";

export const getDiscountCoupons = () => Api.get("admin/getDiscountCoupons");
export const createDiscountCoupon = (payload) => Api.post("admin/createDiscountCoupon", payload);
export const updateDiscountCoupon = (payload) => Api.put("admin/updateDiscountCoupon", payload);
export const deleteDiscountCoupon = (code) => Api.delete(`admin/deleteDiscountCoupon?code=${encodeURIComponent(code)}`);


